import { Product } from "@transfr-inc/dashboard-components/constants";

import { hasAnyProducts } from "@lib/product.utils";

// Single source of truth for curriculum resource tabs.
//   productId    — document set + tracking source for the tab
//   entitlements — product entitlements that reveal the tab (defaults to [productId])
//   filters      — filter keys the tab shows (see utils/constants.js FILTER_DEFINITIONS)
export const PRODUCT_TABS = [
  {
    productId: Product.TRK,
    // Trek VR (CE) or Trek Mobile (TRK) reveals the single Trek tab, which always
    // sources the TRK document set — so a CE+TRK account sees it exactly once.
    entitlements: [Product.TRK, Product.CE],
    name: "TREK",
    label: "Trek",
    filters: ["activity"],
  },
  {
    productId: Product.TS,
    name: "TRAINING",
    label: "Train",
    filters: ["activity", "industry", "simulation", "estimatedTime"],
  },
  {
    productId: Product.PROG,
    name: "PROGRAMS",
    label: "Programs",
    filters: ["activity", "simulation", "estimatedTime"],
  },
];

export const getVisibleTabs = (products, getDocumentCount) =>
  PRODUCT_TABS.filter(
    (tab) =>
      hasAnyProducts(products, tab.entitlements ?? [tab.productId]) &&
      getDocumentCount(tab.productId) > 0
  );
